module.exports = __webpack_public_path__ + "img/GT12.c3d720ee.png";